export const PAAS_COORDS_STALE_AFTER_DAYS = 7;


export const isPaasCoordsStale = (ageDays: number | null): boolean => (
	ageDays == null || ageDays > PAAS_COORDS_STALE_AFTER_DAYS
);


export type PaasCoordsWarning =
	| { kind: 'none' }
	| { kind: 'stale'; days: number }
	| { kind: 'never' };


export const getPaasCoordsWarning = (
	ages: readonly (number | null)[],
): PaasCoordsWarning => {
	const numericAges = ages.filter((age): age is number => age != null);
	if (numericAges.length === 0) {
		return ages.length === 0 ? { kind: 'none' } : { kind: 'never' };
	}
	const freshestAge = Math.min(...numericAges);
	if (isPaasCoordsStale(freshestAge)) {
		return { kind: 'stale', days: freshestAge };
	}
	return { kind: 'none' };
};


export type PaasTaskProblemView = {
	mountpoint: string;
	has_error: boolean;
	message: string;
	warnings: readonly { filename: string; message: string }[];
};


export const findPaasProblemForMountpoint = (
	problems: readonly PaasTaskProblemView[],
	mountpoint: string,
): PaasTaskProblemView | null => (
	problems.find(problem => problem.mountpoint === mountpoint) ?? null
);


export const formatPaasWarningTooltip = (
	warnings: readonly { filename: string; message: string }[],
): string => (
	warnings.map(warning => `${warning.filename}: ${warning.message}`).join('\n')
);
